module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "zk-menu-item",
    class: {
      'is-active': _vm.active,
      'is-disabled': _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-afef479e"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/menu/src/menu-item.vue
// module id = 280
// module chunks = 0